import { render, staticRenderFns } from "./GuidesAndType.vue?vue&type=template&id=500377dd&scoped=true"
import script from "./GuidesAndType.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuidesAndType.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GuidesAndType.vue?vue&type=style&index=0&id=500377dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500377dd",
  null
  
)

export default component.exports